<iframe
    #mapIframe
    *ngIf="iframe_url"
    id="parcel-map"
    title="Cadastral Parcels Map"
    [src]="iframe_url"
    allowfullscreen
    loading="lazy"
    class="iframe-container"
></iframe>
